import { render, staticRenderFns } from "./confirm-with-checkbox.vue?vue&type=template&id=206518fa&scoped=true&lang=html&"
import script from "./confirm-with-checkbox.vue?vue&type=script&lang=js&"
export * from "./confirm-with-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./confirm-with-checkbox.vue?vue&type=style&index=0&id=206518fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206518fa",
  null
  
)

export default component.exports